module.exports = __webpack_public_path__ + "static/media/campana.6cff959f.mp3";